import axios from 'axios';

const DEBUG = false;

const getAPIUrl = () => {
  return (window.runtimeConfig && window.runtimeConfig.TSP_APP_BASE_URL) || '';
};

let apiClient = null;

const initializeApiClient = () => {
  if (apiClient) {
    return apiClient;
  }

  apiClient = axios.create({
    baseURL: getAPIUrl(),
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: false,
  });

  apiClient.interceptors.request.use(
    async (request) => {
      return request;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  apiClient.interceptors.response.use(
    async (response) => {
      return response;
    },
    async (error) => {
      const { response: errorResponse, config, code } = error;
      if (DEBUG) {
        console.log('errorResponse:', errorResponse);
        console.log('config:', config);
        console.log('code:', code);
      }
      return Promise.reject(error);
    }
  );

  return apiClient;
};

export const apiService = async ({ config }) => {
  const client = initializeApiClient();
  const response = await getAxiosCall(config, client);
  return response?.data;
};

export const getAxiosCall = async (config, client = apiClient) => {
  let response;
  if (DEBUG) {
    console.log(
      '___________________________AXIOS CALL___________________________'
    );
    const { method, url, data, headers } = config;
    console.log('method:\n', method);
    console.log('url:\n', url);
    console.log('Headers:\n', headers);
    console.log('body:\n', data);
    console.log(
      '_________________________________________________________________'
    );
  }
  const newConfig = { ...config };
  await client(newConfig)
    .then((res) => {
      response = res;
      return response;
    })
    .catch((err) => {
      response = err?.response ? err?.response : { data: err?.message };
    });
  return response;
};

export const getRequest = async ({ config }) => {
  return await apiService({
    config: {
      method: 'GET',
      ...config,
    },
  });
};

export const postRequest = async ({ config }) => {
  return await apiService({
    config: {
      method: 'POST',
      ...config,
    },
  });
};

export const putRequest = async ({ config }) => {
  return await apiService({
    config: {
      method: 'PUT',
      ...config,
    },
  });
};

export const deleteRequest = async ({ config }) => {
  return await apiService({
    config: {
      method: 'DELETE',
      ...config,
    },
  });
};
